'use strict';

var React = require('react');

var SvgRecentSearchesMajor = function SvgRecentSearchesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8 2c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6zm6.312 10.897 5.395 5.396a1 1 0 1 1-1.414 1.414l-5.396-5.395a7.954 7.954 0 0 1-4.897 1.688c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8a7.946 7.946 0 0 1-1.688 4.897zm-5.312-7.897a1 1 0 1 0-2 0v3a1 1 0 0 0 .293.707l2 2a1 1 0 0 0 1.414-1.414l-1.707-1.707v-2.586z"
  }));
};

exports.SvgRecentSearchesMajor = SvgRecentSearchesMajor;
